const SHERWOOD_APP_SSL_PATH = "https://contest.sherwoodhockey.com/";
const CAPTCHA_IFRAME_PATH = "secureodscontrol/imageframe.php";
const SET_SESSION_PATH = "ajax/setsession.php";
const VERIFY_SESSION_PATH = "ajax/verifysession.php";
const GET_PIN_DETAIL_PATH = "ajax/getpindetail.php";
const GET_CART_PATH = "/cart.js";
const CART_UPDATE_PATH = "/cart/update.js";
const CART_CHANGE_PATH = "/cart/change.js";
const CART_REDIRECT_PATH = "/cart";
const flagRedirectToCart = true;
var currentLanguage = "en";
if (LANGUAGE_DETAIL != "undefined") {
  currentLanguage = LANGUAGE_DETAIL
}
//console.log(currentLanguage);

const emailRegex =
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@(([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3})|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const contactNumberRegex =
  /^\s*(?:\+1)?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;

const postalCodeRegex = {
  US: /^\d{5}(?:-\d{4})?$/,
  CA: /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z] ?\d[ABCEGHJ-NPRSTV-Z]\d$/i,
  UK: /^(GIR ?0AA|[A-PR-UWYZ](?:\d{1,2}|[A-HK-Y]\d{1,2}|\d[A-HJKPSTUW]|[A-HK-Y]\d[ABEHMNPRV-Y]) ?\d[ABD-HJLNP-UW-Z]{2})$/i,
  DE: /^\d{5}$/,
  KR: /^\d{5}$/,
  CZ: /^\d{3}\s?\d{2}$/,
};

const FILE_UPLOAD_MAX_LIMIT = MAX_FILE_SIZE;

const validFileExtensions = VALID_FILE_EXTENSIONS;

const globalErrorMessages = GLOBAL_ERROR_MESSAGES;

var provinceWisePostcode = {};

if (
  typeof PROVINCE_WISE_POST_CODES != "undefined" &&
  PROVINCE_WISE_POST_CODES?.length
) {
  PROVINCE_WISE_POST_CODES.forEach((country) => {
    if (country?.value && country?.provinces?.length) {
      provinceWisePostcode[country.value] = {};
      country.provinces.forEach((province) => {
        provinceWisePostcode[country.value][province.value] =
          province?.initialCharacters ?? [];
      });
    }
  });
}

function getCookieValue(cookieName) {
  var name = cookieName + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  if (cookieName == "PINSERVER-TOKEN") {
    return "0";
  }
  return null;
}

function setCookie(cookieName, cookieValue) {
  if (cookieName == "TOKENTIMEOUT") {
    cookieTimoutToken = cookieValue;
    cookieValue = window.btoa(cookieValue);
  } else {
    cookieTimoutToken = checkTokenTimoutAndRedirect();
  }
  let expires = "expires=" + cookieTimoutToken;
  document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/";
}

function delete_cookie(name) {
  document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
}

function checkTokenTimoutAndRedirect() {
  var cookieTimeOutDetail = getCookieValue("TOKENTIMEOUT");
  if (!cookieTimeOutDetail) {
    // Call ajax for reset all session
    removeFailSessionCookies("all");
    window.location.href = window.location.pathname;
  } else {
    cookieTimeOutDetail = window.atob(cookieTimeOutDetail);
  }
  return cookieTimeOutDetail;
}

function removeFailSessionCookies(flagStep, onlyClientSide = false) {
  if (onlyClientSide) {
    if (flagStep == "pin") {
      delete_cookie("CONTEST-CUSTOMERPIN");
      delete_cookie("CUSTOMER-GRANDPRIZE");
      delete_cookie("CUSTOMER-RELATEDPRIZE");
      delete_cookie("CONTEST-CUSTOMERDETAILS");
    }
    if (flagStep == "all") {
      delete_cookie("CONTEST-CUSTOMERPIN");
      delete_cookie("CUSTOMER-GRANDPRIZE");
      delete_cookie("CUSTOMER-RELATEDPRIZE");
      delete_cookie("CONTEST-CUSTOMERDETAILS");
      delete_cookie("CUSTOMER-AGREETC");
      delete_cookie("CUSTOMER-COLLECTIONID");
    }
  } else {
    var pinServerToken = getCookieValue("PINSERVER-TOKEN");
    var url = SHERWOOD_APP_SSL_PATH + SET_SESSION_PATH;
    $.ajax({
      url: url,
      type: "POST",
      async: false,
      xhrFields: {
        withCredentials: true,
      },
      crossDomain: true,
      data: {
        doAction: "resetSession",
        step: flagStep,
        pinServerToken: pinServerToken,
        r: Math.random(),
      },
      success: function (result) {
        if (result != "") {
          var obj = JSON.parse(result);
          setCookie("PINSERVER-TOKEN", obj?.TOKEN);
          if (obj?.status) {
            if (flagStep == "pin") {
              delete_cookie("CONTEST-CUSTOMERPIN");
              delete_cookie("CUSTOMER-GRANDPRIZE");
              delete_cookie("CUSTOMER-RELATEDPRIZE");
              delete_cookie("CONTEST-CUSTOMERDETAILS");
            }
            if (flagStep == "all") {
              delete_cookie("CONTEST-CUSTOMERPIN");
              delete_cookie("CUSTOMER-GRANDPRIZE");
              delete_cookie("CUSTOMER-RELATEDPRIZE");
              delete_cookie("CONTEST-CUSTOMERDETAILS");
              delete_cookie("CUSTOMER-AGREETC");
              delete_cookie("CUSTOMER-COLLECTIONID");
            }
          }
        }
      },
    });
  }
}

function handelize(str) {
  let newStr = String(str).toLowerCase().replace(/\s+/g, "_");
  return newStr;
}

document.addEventListener("DOMContentLoaded", (event) => {
  //console.log("DOM fully loaded and parsed");
  //console.log("hi");
  if (window?.location?.pathname?.includes("/cart")) {
    validateUserCheckout();
    initPaymentClickEvent();
  } else if (window?.location?.pathname?.includes("/collections/")) {
    verifyCollectionPageCookies();
  }
});

function verifyCollectionPageCookies(params) {
  //console.log("verifyCollectionPageCookies");
  displayMainLoader();
  var pinTimeoutToken = getCookieValue("TOKENTIMEOUT");
  if (!pinTimeoutToken) {
    var datetime = new Date();
    datetime.setTime(datetime.getTime() + 24 * 60 * 60 * 1000);
    setCookie("TOKENTIMEOUT", datetime.toUTCString());
  }
  if (CONTEST_TYPE == "PTRFP") {
    var customerPinCookie = getCookieValue("CONTEST-CUSTOMERPIN");
    var customerRelatedPrizeCookie = getCookieValue("CUSTOMER-RELATEDPRIZE");
    var customerInformationCookie = getCookieValue("CONTEST-CUSTOMERDETAILS");
    var customerGrandPrize = getCookieValue("CUSTOMER-GRANDPRIZE");
    var currentCookiesCollectionId = getCookieValue("CUSTOMER-COLLECTIONID");
    //console.log("customerPinCookie", customerPinCookie);
    if (!customerPinCookie) {
      var url = SHERWOOD_APP_SSL_PATH + VERIFY_SESSION_PATH;
      $.ajax({
        url: url,
        type: "POST",
        async: false,
        xhrFields: {
          withCredentials: true,
        },
        crossDomain: true,
        data: {
          doAction: "verifySession",
          sessionValue: "PININFO,CUSTOMERINFO",
          pinServerToken: getCookieValue("PINSERVER-TOKEN"),
          r: Math.random(),
        },
        success: function (result) {
          if (result != "") {
            var obj = JSON.parse(result);
            //console.log("onload AJAX result", obj);
            setCookie("PINSERVER-TOKEN", obj?.TOKEN);
            if (obj?.PININFO == "Y") {
              currentCookiesCollectionId = obj.sessionData.COLLECTIONID;
              setCookie("CUSTOMER-COLLECTIONID", obj.sessionData.COLLECTIONID);
              customerPinCookie = obj.sessionData.ENTEREDPIN;
              setCookie("CONTEST-CUSTOMERPIN", obj.sessionData.ENTEREDPIN);
              customerGrandPrize = obj.sessionData.GRANDPIN;
              setCookie("CUSTOMER-GRANDPRIZE", obj.sessionData.GRANDPIN);
              customerInformationCookie = obj.sessionData.CUSTOMERDETAILS;
              setCookie(
                "CONTEST-CUSTOMERDETAILS",
                obj.sessionData.CUSTOMERDETAILS
              );
              customerRelatedPrizeCookie = obj.sessionData.RELATEDPRIZE;
              if (
                typeof customerRelatedPrizeCookie != "undefined" &&
                customerRelatedPrizeCookie != null &&
                customerRelatedPrizeCookie != ""
              ) {
                setCookie(
                  "CUSTOMER-RELATEDPRIZE",
                  obj.sessionData.RELATEDPRIZE
                );
              }
            } else {
              removeFailSessionCookies("pin");
            }
          }
        },
      });
    }
    customerPinCookie = getCookieValue("CONTEST-CUSTOMERPIN");
    customerGrandPrize = getCookieValue("CUSTOMER-GRANDPRIZE");
    customerInformationCookie = getCookieValue("CONTEST-CUSTOMERDETAILS");
    customerRelatedPrizeCookie = getCookieValue("CUSTOMER-RELATEDPRIZE");
    currentCookiesCollectionId = getCookieValue("CUSTOMER-COLLECTIONID");
    if (!customerPinCookie) {
      if (!FLAG_CHECK_FUTURE_EXPIRE) {
        //console.log("here");
        displayPinPage();
      } else {
        var currentDate = new Date();
        if (typeof SERVER_CURRENT_DATE != "undefined") {
          currentDate = new Date(SERVER_CURRENT_DATE);
        }
        if (
          typeof CONTEST_START_DATE != "undefined" &&
          typeof CONTEST_END_DATE != "undefined"
        ) {
          var contestStartDate = new Date(CONTEST_START_DATE);
          var contestEndDate = new Date(CONTEST_END_DATE);
          if (currentDate.getTime() < contestStartDate.getTime()) {
            displayFuturePage();
          } else if (currentDate.getTime() > contestEndDate.getTime()) {
            displayExpirePage();
          } else if (
            currentDate.getTime() > contestStartDate.getTime() &&
            currentDate.getTime() < contestEndDate.getTime()
          ) {
            //console.log("here1");
            displayPinPage();
          }
        }
      }
    } else {
      //console.log("else");
      if (currentCookiesCollectionId != COLLECTION_ID) {
        removeFailSessionCookies("pin");
        displayPinPage();
      } else {
        if (customerInformationCookie == "Y") {
          if (customerGrandPrize == "Y") {
            displayGrandPrizeProductDetails();
          } else {
            displayRegularPrizeProductDetails();
          }
        } else {
          displayCustomerInformationPage();
        }
      }
    }
  } else if (CONTEST_TYPE == "STG") {
    var url = SHERWOOD_APP_SSL_PATH + VERIFY_SESSION_PATH;
    $.ajax({
      url: url,
      type: "POST",
      async: false,
      xhrFields: {
        withCredentials: true,
      },
      crossDomain: true,
      data: {
        doAction: "verifySession",
        sessionValue: "PININFO,CUSTOMERINFO",
        pinServerToken: getCookieValue("PINSERVER-TOKEN"),
        r: Math.random(),
      },
      success: function (result) {
        if (result != "") {
          var obj = JSON.parse(result);
          //console.log("onload AJAX result", obj);
          setCookie("PINSERVER-TOKEN", obj?.TOKEN);
          displayCustomerInformationPage();
        }
      },
    });
  }
}

function displayGrandPrizeProductDetails(params) {
  //console.log("displayGrandPrizeProductDetails");
  hideMainLoader();
  scrolltoTop();
}

function displayRegularPrizeProductDetails(params) {
  //console.log("displayRegularPrizeProductDetails");
  if (
    typeof FLAG_CUSTOMER_PRODUCT_SELECTION != "undefined" &&
    FLAG_CUSTOMER_PRODUCT_SELECTION == true
  ) {
    if (
      typeof PRODUCT_SELECTION_LIQUID != "undefined" &&
      document?.querySelector("#collectionInfo")
    ) {
      var productSelectionLiquid = PRODUCT_SELECTION_LIQUID;
      productSelectionLiquid = productSelectionLiquid.replace(
        /##CLOSESCRIPTREPLACE##/g,
        "</script"
      );
      document.querySelector("#collectionInfo").innerHTML =
        productSelectionLiquid;
    }
    hideMainLoader();
    scrolltoTop();
  } else {
    let relatedPrizeTag = getCookieValue("CUSTOMER-RELATEDPRIZE");
    if (typeof productArray != "undefined" && productArray?.find) {
      let firstAvailableProduct = productArray.find(
        (itm) =>
          itm?.available == true &&
          (!relatedPrizeTag || itm?.tags?.includes(relatedPrizeTag))
      );
      if (
        typeof firstAvailableProduct != "undefined" &&
        firstAvailableProduct?.id &&
        firstAvailableProduct?.variants?.find
      ) {
        let firstAvailableVariant = firstAvailableProduct.variants.find(
          (itm) => itm.available == true
        );
        if (
          typeof firstAvailableVariant != "undefined" &&
          firstAvailableVariant?.id
        ) {
          verifyProductAndAddToCart(
            firstAvailableProduct.id,
            firstAvailableVariant.id,
            document.createElement("form")
          );
        } else {
          removeFailSessionCookies("all");
          displayFailCasePage();
        }
      } else {
        removeFailSessionCookies("all");
        displayFailCasePage();
      }
    }
  }
}

function displayFailCasePage(params) {
  //console.log("displayFailCasePage");
  if (
    typeof FAIL_CASE_LIQUID != "undefined" &&
    document?.querySelector("#collectionInfo")
  ) {
    var failCaseLiquid = FAIL_CASE_LIQUID;
    failCaseLiquid = failCaseLiquid.replace(
      /##CLOSESCRIPTREPLACE##/g,
      "</script"
    );

    document.querySelector("#collectionInfo").innerHTML = failCaseLiquid;
  }
  hideMainLoader();
  scrolltoTop();
}

function displayPinPage(params) {
  //console.log("displayPinPage");
  if (
    typeof ENTER_PIN_LIQUID != "undefined" &&
    document?.querySelector("#collectionInfo")
  ) {
    var pinDetail = ENTER_PIN_LIQUID;
    pinDetail = pinDetail.replace(/##CLOSESCRIPTREPLACE##/g, "</script");
    document.querySelector("#collectionInfo").innerHTML = pinDetail;
  }
  hideMainLoader();
  scrolltoTop();
}

function displayCustomerInformationPage(params) {
  //console.log("displayCustomerInformationPage");
  if (
    typeof AFTER_PIN_CUSTOMER_INFORMATION_LIQUID != "undefined" &&
    document?.querySelector("#collectionInfo")
  ) {
    var customerContestDetail = AFTER_PIN_CUSTOMER_INFORMATION_LIQUID;
    customerContestDetail = customerContestDetail.replace(
      /##CLOSESCRIPTREPLACE##/g,
      "</script"
    );
    document.querySelector("#collectionInfo").innerHTML = customerContestDetail;
  }
  renderCountryProvinceSelector();
  reloadIframe();
  hideMainLoader();
  scrolltoTop();
}

function displayFuturePage(params) {
  //console.log("displayFuturePage");
  if (
    typeof FUTURE_CONTEST_LIQUID != "undefined" &&
    document?.querySelector("#collectionInfo")
  ) {
    var futureContestDetail = FUTURE_CONTEST_LIQUID;
    futureContestDetail = futureContestDetail.replace(
      /##CLOSESCRIPTREPLACE##/g,
      "</script"
    );
    document.querySelector("#collectionInfo").innerHTML = futureContestDetail;
  }
  renderCountryProvinceSelector();
  hideMainLoader();
  scrolltoTop();
}

function displayExpirePage(params) {
  //console.log("displayExpirePage");
  if (
    typeof EXPIRE_CONTEST_LIQUID != "undefined" &&
    document?.querySelector("#collectionInfo")
  ) {
    var expireContestDetail = EXPIRE_CONTEST_LIQUID;
    expireContestDetail = expireContestDetail.replace(
      /##CLOSESCRIPTREPLACE##/g,
      "</script"
    );
    document.querySelector("#collectionInfo").innerHTML = expireContestDetail;
  }
  renderCountryProvinceSelector();
  hideMainLoader();
  scrolltoTop();
}

function displayAfterFormSubmitPage(params) {
  console.log("displayAfterFormSubmitPage");
  if (
    typeof AFTER_SUBMIT_INFORMATION_LIQUID != "undefined" &&
    document?.querySelector("#collectionInfo")
  ) {
    var afterSubmitLiquid = AFTER_SUBMIT_INFORMATION_LIQUID;
    afterSubmitLiquid = afterSubmitLiquid.replace(
      /##CLOSESCRIPTREPLACE##/g,
      "</script"
    );
    document.querySelector("#collectionInfo").innerHTML = afterSubmitLiquid;
  }
  hideMainLoader();
  scrollToForm();
}

function renderCountryProvinceSelector(params) {
  //console.log("renderCountryProvinceSelector", DEFAULT_SELECTED_COUTRY);
  if (
    typeof PROVINCE_WISE_POST_CODES != "undefined" &&
    PROVINCE_WISE_POST_CODES?.length
  ) {
    let selected_country = PROVINCE_WISE_POST_CODES[0];
    if (typeof DEFAULT_SELECTED_COUTRY != "undefined") {
      selected_country = PROVINCE_WISE_POST_CODES?.find(
        (itm) =>
          itm.value.toUpperCase() == DEFAULT_SELECTED_COUTRY.toUpperCase()
      );
    }
    if (
      selected_country?.value &&
      document?.querySelector("#lstPTDProvince") &&
      document?.querySelector("#lstPTDCountry")
    ) {
      document.querySelector("#lstPTDCountry").innerHTML = "";
      document.querySelector("#lstPTDProvince").innerHTML = "";
      PROVINCE_WISE_POST_CODES.forEach((country) => {
        let countryOption = document.createElement("option");
        countryOption.setAttribute("value", country.value);
        if (country.value == selected_country.value) {
          countryOption.setAttribute("selected", true);
        }
        countryOption.innerHTML = country.label;
        document.querySelector("#lstPTDCountry").appendChild(countryOption);
      });
      if (
        document
          ?.querySelector("#txtPTDPostalCode")
          ?.getAttribute(`${selected_country.value.toLowerCase()}-placeholder`)
      ) {
        document
          .querySelector("#txtPTDPostalCode")
          .setAttribute(
            "placeholder",
            document
              .querySelector("#txtPTDPostalCode")
              .getAttribute(
                `${selected_country.value.toLowerCase()}-placeholder`
              )
          );
      }
      selected_country.provinces.forEach((province, index) => {
        let provinceOption = document.createElement("option");
        provinceOption.setAttribute("value", province.value);
        if (index == 0) {
          provinceOption.setAttribute("selected", true);
        }
        provinceOption.innerHTML = province.label;
        document.querySelector("#lstPTDProvince").appendChild(provinceOption);
      });
    }
  }
}

function changeCountryProvinceSelctor(selector) {
  //console.log("changeCountryProvinceSelctor");
  if (selector?.value && typeof DEFAULT_SELECTED_COUTRY != "undefined") {
    DEFAULT_SELECTED_COUTRY = selector.value.toUpperCase();
    renderCountryProvinceSelector();
  }
}

function scrollToForm(params = "start") {
  /*
  if (document?.querySelector(".form-container")) {
    document
      .querySelector(".form-container")
      .scrollIntoView({ behavior: "smooth", block: params });
  }
  */
 const header = document.querySelector("#shopify-section-header");
const contest = document.querySelector(".contest-main-container");
console.log("header",header);
console.log("contest", contest)
  if (header && contest) {
    // Get total height (bottom position) of both elements
    const totalOffset = header.offsetHeight + contest.offsetHeight;
    console.log("totalOffset", totalOffset);
    // Scroll to that position
    window.scrollTo({
      top: totalOffset - 70,
      behavior: "smooth"
    });
  }
}

function scrolltoTop(params) {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth",
  });
}

function displayMainLoader() {
  //console.log("displayMainLoader");
  if (document?.querySelector("#contest_loader_div")?.style) {
    document.querySelector("#contest_loader_div").style.display = "flex";
    document.body.classList.add("restrict-scroll");
  }
}

function hideMainLoader() {
  //console.log("hideMainLoader");
  if (document?.querySelector("#contest_loader_div")?.style) {
    document.querySelector("#contest_loader_div").style.display = "none";
    document.body.classList.remove("restrict-scroll");
  }
  initialCheckboxClick();
}

function resetErrorInputs(objForm = {}) {
  if (objForm?.querySelectorAll("input")) {
    objForm.querySelectorAll("input").forEach((element) => {
      if (element?.classList?.remove) {
        element.classList.remove("error-input");
      }
    });
  }
  if (objForm?.querySelectorAll("select")) {
    objForm.querySelectorAll("select").forEach((element) => {
      if (element?.classList?.remove) {
        element.classList.remove("error-input");
      }
    });
  }
  if (objForm?.querySelectorAll("textarea")) {
    objForm.querySelectorAll("textarea").forEach((element) => {
      if (element?.classList?.remove) {
        element.classList.remove("error-input");
      }
    });
  }
}

/** PTRFP RELATED SUBMISSION FUNTIONS **/

function ptrfpPinSubmitFunction(objForm) {
  //console.log("ptrfpPinSubmitFunction");
  const formData = new FormData(objForm);
  let errorMessage = [];
  displayMainLoader();

  if (formData?.get("txtPin")?.trim() == "") {
    errorMessage.push({
      element: objForm.querySelector("#txtPin"),
      message: globalErrorMessages.pin,
    });
  }

  // if (!formData?.get("chkPTDTermCondition")) {
  //   errorMessage.push({
  //     element: objForm.querySelector("#chkPTDTermCondition"),
  //     message: globalErrorMessages.terms_conditions,
  //   });
  // }

  // if (!formData?.get("chkPTDMessage")) {
  //   errorMessage.push({
  //     element: objForm.querySelector("#chkPTDMessage"),
  //     message: globalErrorMessages.consent_check,
  //   });
  // }

  if (objForm?.querySelectorAll("input")) {
    resetErrorInputs(objForm);
  }
  if (errorMessage?.length > 0) {
    if (errorMessage[0]?.element?.classList) {
      errorMessage[0].element.classList.add("error-input");
      if (
        objForm?.querySelector("#divPTDErrorMessage") &&
        objForm?.querySelector("#divPTDError")
      ) {
        objForm.querySelector("#divPTDErrorMessage").innerHTML =
          errorMessage[0].message;
        objForm.querySelector("#divPTDError").style.display = "block";
      }
    }
    hideMainLoader();
  } else {
    let pinFormData = {
      pin: formData?.get("txtPin")?.trim(),
      flagAgreeTermCondition: formData?.get("chkPTDTermCondition") ? "Y" : "N",
      consentDetail: formData?.get("chkPTDMessage") ? "Y" : "N",
    };
    ptrfpCustomerPinForm(pinFormData);
    if (
      objForm?.querySelector("#divPTDErrorMessage") &&
      objForm?.querySelector("#divPTDError")
    ) {
      objForm.querySelector("#divPTDErrorMessage").innerHTML = "";
      objForm.querySelector("#divPTDError").style.display = "none";
    }
  }
  return false;
}

function ptrfpCustomerPinForm(pinFormData = {}) {
  //console.log("ptrfpCustomerPinForm");
  let dataAction = {
    ...pinFormData,
    doAction: "validateOnlyPinDetail",
    collectionId: COLLECTION_ID,
    contestType: CONTEST_TYPE,
    contestCode: CONTEST_CODE,
    contestKlaviyoMatrixName: CONTEST_MATRIX_NAME,
    pinServerToken: getCookieValue("PINSERVER-TOKEN"),
    r: Math.random(),
  };
  //console.log("pinFormData: ", dataAction);
  var url = SHERWOOD_APP_SSL_PATH + GET_PIN_DETAIL_PATH;
  var currentPinTime = new Date();
  $.ajax({
    url: url,
    type: "POST",
    xhrFields: {
      withCredentials: true,
    },
    crossDomain: true,
    data: dataAction,
    success: function (result) {
      if (result != "") {
        let obj = JSON.parse(result);
        setCookie("PINSERVER-TOKEN", obj.TOKEN);
        if (obj.status) {
          var afterAjaxTime = new Date();
          var executionTimeInSeconds =
            (afterAjaxTime.getTime() - currentPinTime.getTime()) / 1000;
          var flagSetTimeOut = false;
          var timeoutData = 4 - executionTimeInSeconds;
          if (executionTimeInSeconds < 4) {
            flagSetTimeOut = true;
          }
          timeoutData = timeoutData * 1000;
          setTimeout(function () {
            if (obj?.flagValidPin) {
              if (obj?.collectionId) {
                setCookie("CUSTOMER-COLLECTIONID", obj.collectionId);
              } else {
                setCookie("CUSTOMER-COLLECTIONID", COLLECTION_ID);
              }
              if (obj?.validPin) {
                setCookie("CONTEST-CUSTOMERPIN", obj.validPin);
              }
              if (obj?.relatedprize) {
                setCookie("CUSTOMER-RELATEDPRIZE", obj.relatedprize);
              }
              if (obj?.flagGrandPrize) {
                setCookie("CUSTOMER-GRANDPRIZE", obj.flagGrandPrize);
              }
              if (obj?.flagCustomerDetailsSubmitted) {
                setCookie(
                  "CONTEST-CUSTOMERDETAILS",
                  obj.flagCustomerDetailsSubmitted
                );
              }
              if (obj?.flagCustomerDetailsSubmitted == "Y") {
                displayRegularPrizeProductDetails();
              } else {
                displayCustomerInformationPage();
              }
            } else {
              removeFailSessionCookies("all");
              displayFailCasePage();
            }
          }, timeoutData);
        } else {
          removeFailSessionCookies("all");
          displayFailCasePage();
        }
      }
    },
  });
}

function ptrfpCustomerFormSubmitFunction(objForm) {
  //console.log("ptrfpCustomerFormSubmitFunction");
  const formData = new FormData(objForm);
  let captchaMandatory = false;
  let errorMessage = [];
  displayMainLoader();
  if (formData?.get("txtPTDFirstName")?.trim() == "") {
    errorMessage.push({
      element: objForm.querySelector("#txtPTDFirstName"),
      message: globalErrorMessages.first_name,
    });
  }

  if (formData?.get("txtPTDLastName")?.trim() == "") {
    errorMessage.push({
      element: objForm.querySelector("#txtPTDLastName"),
      message: globalErrorMessages.last_name,
    });
  }

  if (formData?.get("txtPTDEmail")?.trim() == "") {
    errorMessage.push({
      element: objForm.querySelector("#txtPTDEmail"),
      message: globalErrorMessages.email_empty,
    });
  } else if (!emailRegex.test(formData?.get("txtPTDEmail"))) {
    errorMessage.push({
      element: objForm.querySelector("#txtPTDEmail"),
      message: globalErrorMessages.email_invalid,
    });
  }

  if (formData?.get("txtContactNumber")?.trim() == "") {
    errorMessage.push({
      element: objForm.querySelector("#txtContactNumber"),
      message: globalErrorMessages.contact_empty,
    });
  } else if (!contactNumberRegex.test(formData?.get("txtContactNumber"))) {
    errorMessage.push({
      element: objForm.querySelector("#txtContactNumber"),
      message: globalErrorMessages.contact_invalid,
    });
  }

  if (formData?.get("txtPTDDay")?.trim() == "") {
    errorMessage.push({
      element: objForm.querySelector("#txtPTDDay"),
      message: globalErrorMessages.day_empty,
    });
  } else {
    let selectedDay = formData.get("txtPTDDay").trim();
    if (
      isNaN(selectedDay) ||
      !(parseInt(selectedDay) >= 1 && parseInt(selectedDay) <= 31)
    ) {
      errorMessage.push({
        element: objForm.querySelector("#txtPTDDay"),
        message: globalErrorMessages.day_invalid,
      });
    }
  }

  if (formData?.get("txtPTDMonth")?.trim() == "") {
    errorMessage.push({
      element: objForm.querySelector("#txtPTDMonth"),
      message: globalErrorMessages.month_empty,
    });
  } else {
    let selectedMonth = formData.get("txtPTDMonth").trim();
    if (
      isNaN(selectedMonth) ||
      !(parseInt(selectedMonth) >= 1 && parseInt(selectedMonth) <= 12)
    ) {
      errorMessage.push({
        element: objForm.querySelector("#txtPTDMonth"),
        message: globalErrorMessages.month_invalid,
      });
    }
  }

  if (formData?.get("txtPTDYear")?.trim() == "") {
    errorMessage.push({
      element: objForm.querySelector("#txtPTDYear"),
      message: globalErrorMessages.year_empty,
    });
  } else {
    let selectedYear = formData.get("txtPTDYear").trim();
    if (isNaN(selectedYear) || selectedYear?.length > 4) {
      errorMessage.push({
        element: objForm.querySelector("#txtPTDYear"),
        message: globalErrorMessages.year_invalid,
      });
    }
  }

  let selectedDate = new Date(
    `${formData.get("txtPTDYear").trim()}-${formData
      .get("txtPTDMonth")
      .trim()}-${formData.get("txtPTDDay").trim()}`
  );
  let currentDate = new Date();
  /*
  //console.log("selectedDate", selectedDate);
  //console.log("selectedDate?.getUTCDate()", selectedDate?.getUTCDate());
  //console.log("selectedDate?.getUTCMonth()", selectedDate?.getUTCMonth() + 1);
  //console.log("selectedDate?.getUTCFullYear()", selectedDate?.getUTCFullYear());
  //console.log(
    "formData.get('txtPTDDay').trim()",
    parseInt(formData.get("txtPTDDay").trim())
  );
  //console.log(
    "formData.get('txtPTDMonth').trim()",
    parseInt(formData.get("txtPTDMonth").trim())
  );
  //console.log(
    "formData.get('txtPTDYear').trim()",
    parseInt(formData.get("txtPTDYear").trim())
  );
  */
  if (
    isNaN(selectedDate?.getUTCDate()) ||
    selectedDate?.getUTCDate() != parseInt(formData.get("txtPTDDay").trim()) ||
    isNaN(selectedDate?.getUTCMonth()) ||
    selectedDate?.getUTCMonth() + 1 !=
    parseInt(formData.get("txtPTDMonth").trim()) ||
    isNaN(selectedDate?.getUTCFullYear()) ||
    selectedDate?.getUTCFullYear() !=
    parseInt(formData.get("txtPTDYear").trim()) ||
    selectedDate?.getTime() > currentDate?.getTime()
  ) {
    errorMessage.push({
      element: objForm.querySelector("#txtPTDDay"),
      message: globalErrorMessages.date_invalid,
    });
  }

  if (
    typeof MINIMUM_AGE_REQUIRED != "undefined" &&
    parseInt(MINIMUM_AGE_REQUIRED) > 0
  ) {
    let customerAge = getAge(
      `${formData.get("txtPTDYear").trim()}-${formData
        .get("txtPTDMonth")
        .trim()}-${formData.get("txtPTDDay").trim()}`
    );
    if (parseInt(MINIMUM_AGE_REQUIRED) > customerAge) {
      errorMessage.push({
        element: objForm.querySelector("#txtPTDYear"),
        message: globalErrorMessages.age_invalid.replace(
          "##AGE##",
          MINIMUM_AGE_REQUIRED
        ),
      });
    }
  }

  if (formData?.get("txtPTDAddress1")?.trim() == "") {
    errorMessage.push({
      element: objForm.querySelector("#txtPTDAddress1"),
      message: globalErrorMessages.street_address,
    });
  }

  if (formData?.get("txtPTDCity")?.trim() == "") {
    errorMessage.push({
      element: objForm.querySelector("#txtPTDCity"),
      message: globalErrorMessages.city,
    });
  }

  if (formData?.get("txtPTDPostalCode")?.trim() == "") {
    if (formData?.get("lstPTDCountry")?.trim().toLowerCase() == "us") {
      errorMessage.push({
        element: objForm.querySelector("#txtPTDPostalCode"),
        message: globalErrorMessages.zip_code_empty,
      });
    } else {
      errorMessage.push({
        element: objForm.querySelector("#txtPTDPostalCode"),
        message: globalErrorMessages.postal_code_empty,
      });
    }
  }

  if (
    formData?.get("lstPTDProvince") == "default" ||
    formData?.get("lstPTDProvince")?.trim() == ""
  ) {
    if (formData?.get("lstPTDCountry")?.trim().toLowerCase() == "us") {
      errorMessage.push({
        element: objForm.querySelector("#lstPTDProvince"),
        message: globalErrorMessages.state,
      });
    } else {
      errorMessage.push({
        element: objForm.querySelector("#lstPTDProvince"),
        message: globalErrorMessages.province,
      });
    }
  }

  if (formData?.get("lstPTDCountry")?.trim() == "") {
    errorMessage.push({
      element: objForm.querySelector("#lstPTDCountry"),
      message: globalErrorMessages.country,
    });
  }

  if (
    provinceWisePostcode?.[formData.get("lstPTDCountry").trim()]?.[
    formData?.get("lstPTDProvince").trim()
    ] &&
    formData?.get("txtPTDPostalCode")
  ) {
    let selectedProvince =
      provinceWisePostcode[formData.get("lstPTDCountry").trim()][
      formData?.get("lstPTDProvince").trim()
      ];
    if (
      !["DE", "KR", "CZ"].includes(formData.get("lstPTDCountry").trim()) &&
      !selectedProvince.includes(
        formData.get("txtPTDPostalCode")?.trim()?.toUpperCase()?.charAt(0)
      )
    ) {
      if (formData?.get("lstPTDCountry")?.trim().toLowerCase() == "us") {
        errorMessage.push({
          element: objForm.querySelector("#txtPTDPostalCode"),
          message: globalErrorMessages.zip_code_invalid,
        });
      } else {
        console.log("3")
        errorMessage.push({
          element: objForm.querySelector("#txtPTDPostalCode"),
          message: globalErrorMessages.postal_code_invalid,
        });
      }
    }
  }

  if (
    !postalCodeRegex[formData.get("lstPTDCountry").trim().toUpperCase()]?.test(
      formData?.get("txtPTDPostalCode")
    )
  ) {
    if (formData?.get("lstPTDCountry")?.trim().toLowerCase() == "us") {
      errorMessage.push({
        element: objForm.querySelector("#txtPTDPostalCode"),
        message: globalErrorMessages.zip_code_invalid,
      });
    } else {
      console.log("4")
      errorMessage.push({
        element: objForm.querySelector("#txtPTDPostalCode"),
        message: globalErrorMessages.postal_code_invalid,
      });
    }
  }

  if (
    formData?.get("PTDverificationImage")?.size > 0 &&
    formData?.get("PTDverificationImage")?.name != ""
  ) {
    let uploadedFile = formData.get("PTDverificationImage");
    if (typeof FILE_UPLOAD_MAX_LIMIT != "undefined") {
      const maxSize = FILE_UPLOAD_MAX_LIMIT * 1024 * 1024; // convert bytes to MB
      if (uploadedFile?.size > maxSize) {
        errorMessage.push({
          element: objForm.querySelector("#PTDverificationImage"),
          message: globalErrorMessages.file_size.replace(
            "##SIZE##",
            FILE_UPLOAD_MAX_LIMIT
          ),
        });
      }
      if (
        !validFileExtensions?.includes(
          uploadedFile.name
            .split(".")
          [uploadedFile.name.split(".").length - 1].toLowerCase()
        )
      ) {
        errorMessage.push({
          element: objForm.querySelector("#PTDverificationImage"),
          message: globalErrorMessages.file_invalid,
        });
      }
    }
  } else {
    errorMessage.push({
      element: objForm.querySelector("#PTDverificationImage"),
      message: globalErrorMessages.file_empty,
    });
  }

  if (
    typeof PROVINCE_WISE_POST_CODES != "undefined" &&
    PROVINCE_WISE_POST_CODES?.length
  ) {
    let selected_country = PROVINCE_WISE_POST_CODES?.find(
      (itm) =>
        itm.value.toUpperCase() ==
        formData?.get("lstPTDCountry")?.trim()?.toUpperCase()
    );
    if (
      typeof selected_country != "undefined" &&
      selected_country?.captchaMandatory
    ) {
      captchaMandatory = true;
      if (formData?.get("txtCharacters")?.trim() == "") {
        errorMessage.push({
          element: objForm.querySelector("#txtCharacters"),
          message: globalErrorMessages.captcha,
        });
      }
    }
  }

  if (!formData?.get("chkPTDTermCondition")) {
    errorMessage.push({
      element: objForm.querySelector("#chkPTDTermCondition"),
      message: globalErrorMessages.terms_conditions,
    });
  }

  if (!formData?.get("chkPTDMessage")) {
    errorMessage.push({
      element: objForm.querySelector("#chkPTDMessage"),
      message: globalErrorMessages.consent_check,
    });
  }

  if (objForm?.querySelectorAll("input")) {
    resetErrorInputs(objForm);
  }
  if (errorMessage?.length > 0) {
    if (errorMessage[0]?.element?.classList) {
      errorMessage[0].element.classList.add("error-input");
      if (
        objForm?.querySelector("#divPTDErrorMessage") &&
        objForm?.querySelector("#divPTDError")
      ) {
        objForm.querySelector("#divPTDErrorMessage").innerHTML =
          errorMessage[0].message;
        objForm.querySelector("#divPTDError").style.display = "block";
      }
    }
    hideMainLoader();
  } else {
    let pinFormData = {
      txtPTDFirstName: formData?.get("txtPTDFirstName")?.trim(),
      txtPTDLastName: formData?.get("txtPTDLastName")?.trim(),
      txtPTDEmail: formData?.get("txtPTDEmail")?.trim(),
      txtContactNumber: formData?.get("txtContactNumber")?.trim(),
      customerDob: `${formData.get("txtPTDYear").trim()}-${formData
        .get("txtPTDMonth")
        .trim()}-${formData.get("txtPTDDay").trim()}`,
      minimumAgeRequired: parseInt(MINIMUM_AGE_REQUIRED),
      txtPTDAddress1: formData?.get("txtPTDAddress1")?.trim(),
      txtPTDAddress2: formData?.get("txtPTDAddress2")?.trim() ?? "",
      txtPTDCity: formData?.get("txtPTDCity")?.trim(),
      postalCode: formData?.get("txtPTDPostalCode")?.trim(),
      captchaKey: formData?.get("txtCharacters")?.trim() ?? "",
      captchaMandatory: captchaMandatory,
      provinceCode: formData?.get("lstPTDProvince")?.trim(),
      country: formData?.get("lstPTDCountry")?.trim(),
      uploadedFile: formData?.get("PTDverificationImage"),
      flagAgreeTermCondition: formData?.get("chkPTDTermCondition") ? "Y" : "N",
      consentDetail: formData?.get("chkPTDMessage") ? "Y" : "N",
      hidLanguage: currentLanguage
    };
    //console.log("submitting to AJAX");
    ptrfpCustomerDetailForm(pinFormData, objForm);
    if (
      objForm?.querySelector("#divPTDErrorMessage") &&
      objForm?.querySelector("#divPTDError")
    ) {
      objForm.querySelector("#divPTDErrorMessage").innerHTML = "";
      objForm.querySelector("#divPTDError").style.display = "none";
    }
  }
  return false;
}

function ptrfpCustomerDetailForm(pinFormData = {}, formElement = {}) {
  //console.log("ptrfpCustomerDetailForm");
  let dataAction = {
    ...pinFormData,
    doAction: "validateCustomerDetailAfterPin",
    collectionId: COLLECTION_ID,
    contestType: CONTEST_TYPE,
    contestCode: CONTEST_CODE,
    contestKlaviyoMatrixName: CONTEST_MATRIX_NAME,
    pin: getCookieValue("CONTEST-CUSTOMERPIN"),
    relatedPrize: getCookieValue("CUSTOMER-RELATEDPRIZE"),
    pinServerToken: getCookieValue("PINSERVER-TOKEN"),
    r: Math.random(),
  };
  let mainFormData = getFormData(dataAction);
  //console.log("pinFormData: ", dataAction);
  var url = SHERWOOD_APP_SSL_PATH + GET_PIN_DETAIL_PATH;
  var currentPinTime = new Date();
  $.ajax({
    url: url,
    type: "POST",
    xhrFields: {
      withCredentials: true,
    },
    crossDomain: true,
    contentType: false, // Don't set content-type as FormData handles it
    processData: false, // Don't let jQuery process the data
    data: mainFormData,
    success: function (result) {
      if (result != "") {
        let obj = JSON.parse(result);
        setCookie("PINSERVER-TOKEN", obj.TOKEN);
        //console.log("obj", obj);
        if (obj.status) {
          var afterAjaxTime = new Date();
          var executionTimeInSeconds =
            (afterAjaxTime.getTime() - currentPinTime.getTime()) / 1000;
          var flagSetTimeOut = false;
          var timeoutData = 4 - executionTimeInSeconds;
          if (executionTimeInSeconds < 4) {
            flagSetTimeOut = true;
          }
          timeoutData = timeoutData * 1000;
          //console.log("timeoutData", timeoutData);
          setTimeout(function () {
            if (
              obj?.flagValidPin &&
              obj?.flagValidAge &&
              obj?.flagValidCaptcha
            ) {
              if (obj?.validPin) {
                setCookie("CONTEST-CUSTOMERPIN", obj.validPin);
              }
              // if (obj?.minimumAgeRequired) {
              //   setCookie("CONTEST-MINIMUMAGEREQUIRED", obj.minimumAgeRequired);
              // }
              if (obj?.relatedprize) {
                setCookie("CUSTOMER-RELATEDPRIZE", obj.relatedprize);
              }
              if (obj?.flagGrandPrize) {
                setCookie("CUSTOMER-GRANDPRIZE", obj.flagGrandPrize);
              }
              if (obj?.flagCustomerDetailsSubmitted) {
                setCookie(
                  "CONTEST-CUSTOMERDETAILS",
                  obj.flagCustomerDetailsSubmitted
                );
              }
              if (obj?.flagCustomerDetailsSubmitted == "Y") {
                displayRegularPrizeProductDetails();
              } else {
                displayCustomerInformationPage();
              }
            } else if (!obj?.flagValidCaptcha) {
              if (
                formElement?.querySelector("#divPTDErrorMessage") &&
                formElement?.querySelector("#divPTDError")
              ) {
                formElement.querySelector("#divPTDErrorMessage").innerHTML =
                  globalErrorMessages.captcha_invalid;
                formElement.querySelector("#divPTDError").style.display =
                  "block";
              }
              reloadIframe();
              hideMainLoader();
            } else if (!obj?.flagValidAge) {
              if (
                formElement?.querySelector("#divPTDErrorMessage") &&
                formElement?.querySelector("#divPTDError") &&
                typeof MINIMUM_AGE_REQUIRED != "undefined"
              ) {
                formElement.querySelector("#divPTDErrorMessage").innerHTML =
                  globalErrorMessages.age_invalid.replace(
                    "##AGE##",
                    MINIMUM_AGE_REQUIRED
                  );
                formElement.querySelector("#divPTDError").style.display =
                  "block";
              }
              hideMainLoader();
            } else {
              removeFailSessionCookies("all");
              displayPinPage();
            }
          }, timeoutData);
        } else {
          removeFailSessionCookies("all");
          displayFailCasePage();
        }
      }
    },
  });
}

/** STG RELATED SUBMISSION FUNTIONS **/

function stgCustomerFormSubmitFunction(objForm) {
  //console.log("stgCustomerFormSubmitFunction");
  const formData = new FormData(objForm);
  let captchaMandatory = false;
  let errorMessage = [];
  displayMainLoader();
  if (formData?.get("txtPTDFirstName")?.trim() == "") {
    errorMessage.push({
      element: objForm.querySelector("#txtPTDFirstName"),
      message: globalErrorMessages.first_name,
    });
  }

  if (formData?.get("txtPTDLastName")?.trim() == "") {
    errorMessage.push({
      element: objForm.querySelector("#txtPTDLastName"),
      message: globalErrorMessages.last_name,
    });
  }

  if (formData?.get("txtPTDEmail")?.trim() == "") {
    errorMessage.push({
      element: objForm.querySelector("#txtPTDEmail"),
      message: globalErrorMessages.email_empty,
    });
  } else if (!emailRegex.test(formData?.get("txtPTDEmail"))) {
    errorMessage.push({
      element: objForm.querySelector("#txtPTDEmail"),
      message: globalErrorMessages.email_invalid,
    });
  }

  if (formData?.get("txtContactNumber")?.trim() == "") {
    errorMessage.push({
      element: objForm.querySelector("#txtContactNumber"),
      message: globalErrorMessages.contact_empty,
    });
  } else if (!contactNumberRegex.test(formData?.get("txtContactNumber"))) {
    errorMessage.push({
      element: objForm.querySelector("#txtContactNumber"),
      message: globalErrorMessages.contact_invalid,
    });
  }

  if (formData?.get("txtPTDDay")?.trim() == "") {
    errorMessage.push({
      element: objForm.querySelector("#txtPTDDay"),
      message: globalErrorMessages.day_empty,
    });
  } else {
    let selectedDay = formData.get("txtPTDDay").trim();
    if (
      isNaN(selectedDay) ||
      !(parseInt(selectedDay) >= 1 && parseInt(selectedDay) <= 31)
    ) {
      errorMessage.push({
        element: objForm.querySelector("#txtPTDDay"),
        message: globalErrorMessages.day_invalid,
      });
    }
  }

  if (formData?.get("txtPTDMonth")?.trim() == "") {
    errorMessage.push({
      element: objForm.querySelector("#txtPTDMonth"),
      message: globalErrorMessages.month_empty,
    });
  } else {
    let selectedMonth = formData.get("txtPTDMonth").trim();
    if (
      isNaN(selectedMonth) ||
      !(parseInt(selectedMonth) >= 1 && parseInt(selectedMonth) <= 12)
    ) {
      errorMessage.push({
        element: objForm.querySelector("#txtPTDMonth"),
        message: globalErrorMessages.month_invalid,
      });
    }
  }

  if (formData?.get("txtPTDYear")?.trim() == "") {
    errorMessage.push({
      element: objForm.querySelector("#txtPTDYear"),
      message: globalErrorMessages.year_empty,
    });
  } else {
    let selectedYear = formData.get("txtPTDYear").trim();
    if (isNaN(selectedYear) || selectedYear?.length > 4) {
      errorMessage.push({
        element: objForm.querySelector("#txtPTDYear"),
        message: globalErrorMessages.year_invalid,
      });
    }
  }

  let selectedDate = new Date(
    `${formData.get("txtPTDYear").trim()}-${formData
      .get("txtPTDMonth")
      .trim()}-${formData.get("txtPTDDay").trim()}`
  );
  let currentDate = new Date();
  if (
    isNaN(selectedDate?.getUTCDate()) ||
    selectedDate?.getUTCDate() != parseInt(formData.get("txtPTDDay").trim()) ||
    isNaN(selectedDate?.getUTCMonth()) ||
    selectedDate?.getUTCMonth() + 1 !=
    parseInt(formData.get("txtPTDMonth").trim()) ||
    isNaN(selectedDate?.getUTCFullYear()) ||
    selectedDate?.getUTCFullYear() !=
    parseInt(formData.get("txtPTDYear").trim()) ||
    selectedDate?.getTime() > currentDate?.getTime()
  ) {
    errorMessage.push({
      element: objForm.querySelector("#txtPTDDay"),
      message: globalErrorMessages.date_invalid,
    });
  }

  if (
    typeof MINIMUM_AGE_REQUIRED != "undefined" &&
    parseInt(MINIMUM_AGE_REQUIRED) > 0
  ) {
    let customerAge = getAge(
      `${formData.get("txtPTDYear").trim()}-${formData
        .get("txtPTDMonth")
        .trim()}-${formData.get("txtPTDDay").trim()}`
    );
    if (parseInt(MINIMUM_AGE_REQUIRED) > customerAge) {
      errorMessage.push({
        element: objForm.querySelector("#txtPTDYear"),
        message: globalErrorMessages.age_invalid.replace(
          "##AGE##",
          MINIMUM_AGE_REQUIRED
        ),
      });
    }
  }

  if (formData?.get("txtPTDAddress1")?.trim() == "") {
    errorMessage.push({
      element: objForm.querySelector("#txtPTDAddress1"),
      message: globalErrorMessages.street_address,
    });
  }

  if (formData?.get("txtPTDCity")?.trim() == "") {
    errorMessage.push({
      element: objForm.querySelector("#txtPTDCity"),
      message: globalErrorMessages.city,
    });
  }

  if (formData?.get("txtPTDPostalCode")?.trim() == "") {
    if (formData?.get("lstPTDCountry")?.trim().toLowerCase() == "us") {
      errorMessage.push({
        element: objForm.querySelector("#txtPTDPostalCode"),
        message: globalErrorMessages.zip_code_empty,
      });
    } else {
      errorMessage.push({
        element: objForm.querySelector("#txtPTDPostalCode"),
        message: globalErrorMessages.postal_code_empty,
      });
    }
  }

  if (
    formData?.get("lstPTDProvince") == "default" ||
    formData?.get("lstPTDProvince")?.trim() == ""
  ) {
    if (formData?.get("lstPTDCountry")?.trim().toLowerCase() == "us") {
      errorMessage.push({
        element: objForm.querySelector("#lstPTDProvince"),
        message: globalErrorMessages.state,
      });
    } else {
      errorMessage.push({
        element: objForm.querySelector("#lstPTDProvince"),
        message: globalErrorMessages.province,
      });
    }
  }

  if (formData?.get("lstPTDCountry")?.trim() == "") {
    errorMessage.push({
      element: objForm.querySelector("#lstPTDCountry"),
      message: globalErrorMessages.country,
    });
  }

  if (
    provinceWisePostcode?.[formData.get("lstPTDCountry").trim()]?.[
    formData?.get("lstPTDProvince").trim()
    ] &&
    formData?.get("txtPTDPostalCode")
  ) {
    let selectedProvince =
      provinceWisePostcode[formData.get("lstPTDCountry").trim()][
      formData?.get("lstPTDProvince").trim()
      ];
    if (
      !["DE", "KR", "CZ"].includes(formData.get("lstPTDCountry").trim()) &&
      !selectedProvince.includes(
        formData.get("txtPTDPostalCode")?.trim()?.toUpperCase()?.charAt(0)
      )
    ) {
      if (formData?.get("lstPTDCountry")?.trim().toLowerCase() == "us") {
        errorMessage.push({
          element: objForm.querySelector("#txtPTDPostalCode"),
          message: globalErrorMessages.zip_code_invalid,
        });
      } else {
        console.log("5")
        errorMessage.push({
          element: objForm.querySelector("#txtPTDPostalCode"),
          message: globalErrorMessages.postal_code_invalid,
        });
      }
    }
  }

  if (
    !postalCodeRegex[formData.get("lstPTDCountry").trim().toUpperCase()]?.test(
      formData?.get("txtPTDPostalCode")
    )
  ) {
    if (formData?.get("lstPTDCountry")?.trim().toLowerCase() == "us") {
      errorMessage.push({
        element: objForm.querySelector("#txtPTDPostalCode"),
        message: globalErrorMessages.zip_code_invalid,
      });
    } else {
      console.log("6")
      errorMessage.push({
        element: objForm.querySelector("#txtPTDPostalCode"),
        message: globalErrorMessages.postal_code_invalid,
      });
    }
  }

  if (formData?.get("txtNoPinDetail")?.trim() == "") {
    errorMessage.push({
      element: objForm.querySelector("#txtNoPinDetail"),
      message: globalErrorMessages.essay_empty,
    });
  }

  if (
    typeof PROVINCE_WISE_POST_CODES != "undefined" &&
    PROVINCE_WISE_POST_CODES?.length
  ) {
    let selected_country = PROVINCE_WISE_POST_CODES?.find(
      (itm) =>
        itm.value.toUpperCase() ==
        formData?.get("lstPTDCountry")?.trim()?.toUpperCase()
    );
    if (
      typeof selected_country != "undefined" &&
      selected_country?.captchaMandatory
    ) {
      captchaMandatory = true;
      if (formData?.get("txtCharacters")?.trim() == "") {
        errorMessage.push({
          element: objForm.querySelector("#txtCharacters"),
          message: globalErrorMessages.captcha,
        });
      }
    }
  }

  if (!formData?.get("chkPTDTermCondition")) {
    errorMessage.push({
      element: objForm.querySelector("#chkPTDTermCondition"),
      message: globalErrorMessages.terms_conditions,
    });
  }

  // if (!formData?.get("chkPTDMessage")) {
  //   errorMessage.push({
  //     element: objForm.querySelector("#chkPTDMessage"),
  //     message: globalErrorMessages.consent_check,
  //   });
  // }

  if (objForm?.querySelectorAll("input")) {
    resetErrorInputs(objForm);
  }
  //console.log("errorMessage", errorMessage);
  if (errorMessage?.length > 0) {
    if (errorMessage[0]?.element?.classList) {
      errorMessage[0].element.classList.add("error-input");
      if (
        objForm?.querySelector("#divPTDErrorMessage") &&
        objForm?.querySelector("#divPTDError")
      ) {
        objForm.querySelector("#divPTDErrorMessage").innerHTML =
          errorMessage[0].message;
        objForm.querySelector("#divPTDError").style.display = "block";
      }
    }
    //console.log("if");
    hideMainLoader();
  } else {
    //console.log("else");
    if (typeof ADDITIONAL_COLLECTION_DETAILS != "undefined") {
      let pinFormData = {
        txtPTDFirstName: formData?.get("txtPTDFirstName")?.trim(),
        txtPTDLastName: formData?.get("txtPTDLastName")?.trim(),
        txtPTDEmail: formData?.get("txtPTDEmail")?.trim(),
        txtContactNumber: formData?.get("txtContactNumber")?.trim(),
        customerDob: `${formData.get("txtPTDYear").trim()}-${formData
          .get("txtPTDMonth")
          .trim()}-${formData.get("txtPTDDay").trim()}`,
        minimumAgeRequired: parseInt(MINIMUM_AGE_REQUIRED),
        txtPTDAddress1: formData?.get("txtPTDAddress1")?.trim(),
        txtPTDAddress2: formData?.get("txtPTDAddress2")?.trim() ?? "",
        txtPTDCity: formData?.get("txtPTDCity")?.trim(),
        postalCode: formData?.get("txtPTDPostalCode")?.trim(),
        essay: formData?.get("txtNoPinDetail")?.trim(),
        captchaKey: formData?.get("txtCharacters")?.trim() ?? "",
        captchaMandatory: captchaMandatory,
        provinceCode: formData?.get("lstPTDProvince")?.trim(),
        country: formData?.get("lstPTDCountry")?.trim(),
        flagAgreeTermCondition: formData?.get("chkPTDTermCondition")
          ? "Y"
          : "N",
        consentDetail: formData?.get("chkPTDMessage") ? "Y" : "N",
        collectionDetails: ADDITIONAL_COLLECTION_DETAILS,
        hidLanguage: currentLanguage
      };
      stgCustomerDetailForm(pinFormData, objForm);
    }
    if (
      objForm?.querySelector("#divPTDErrorMessage") &&
      objForm?.querySelector("#divPTDError")
    ) {
      objForm.querySelector("#divPTDErrorMessage").innerHTML = "";
      objForm.querySelector("#divPTDError").style.display = "none";
    }
  }
  return false;
}

function stgCustomerDetailForm(pinFormData = {}, formElement = {}) {
  //console.log("stgCustomerDetailForm");
  let dataAction = {
    ...pinFormData,
    doAction: "validateCustomerAndReturnPin",
    collectionId: COLLECTION_ID,
    contestType: CONTEST_TYPE,
    contestCode: CONTEST_CODE,
    contestKlaviyoMatrixName: CONTEST_MATRIX_NAME,
    pinServerToken: getCookieValue("PINSERVER-TOKEN"),
    r: Math.random(),
  };
  //console.log("pinFormData: ", dataAction);
  var url = SHERWOOD_APP_SSL_PATH + GET_PIN_DETAIL_PATH;
  var currentPinTime = new Date();
  //console.log("URL", url);
  
  $.ajax({
    url: url,
    type: "POST",
    xhrFields: {
      withCredentials: true,
    },
    crossDomain: true,
    data: dataAction,
    success: function (result) {
      //console.log("result", result);
      var obj = JSON.parse(result);
      if (result != "") {
        if (
          obj?.flagValidAge &&
          obj?.flagValidCaptcha
        ) {
          displayAfterFormSubmitPage();
        } else if (!obj?.flagValidCaptcha) {
          if (
            formElement?.querySelector("#divPTDErrorMessage") &&
            formElement?.querySelector("#divPTDError")
          ) {
            formElement.querySelector("#divPTDErrorMessage").innerHTML =
              globalErrorMessages.captcha_invalid;
            formElement.querySelector("#divPTDError").style.display =
              "block";
          }
          reloadIframe();
          hideMainLoader();
        } else if (!obj?.flagValidAge) {
          if (
            formElement?.querySelector("#divPTDErrorMessage") &&
            formElement?.querySelector("#divPTDError") &&
            typeof MINIMUM_AGE_REQUIRED != "undefined"
          ) {
            formElement.querySelector("#divPTDErrorMessage").innerHTML =
              globalErrorMessages.age_invalid.replace(
                "##AGE##",
                MINIMUM_AGE_REQUIRED
              );
            formElement.querySelector("#divPTDError").style.display =
              "block";
          }
          hideMainLoader();
        }
        // let obj = JSON.parse(result);
        // setCookie("PINSERVER-TOKEN", obj.TOKEN);
        // if (obj.status) {
        //   var afterAjaxTime = new Date();
        //   var executionTimeInSeconds =
        //     (afterAjaxTime.getTime() - currentPinTime.getTime()) / 1000;
        //   var flagSetTimeOut = false;
        //   var timeoutData = 4 - executionTimeInSeconds;
        //   if (executionTimeInSeconds < 4) {
        //     flagSetTimeOut = true;
        //   }
        //   timeoutData = timeoutData * 1000;
        //   setTimeout(function () {
        //     if (obj?.flagValidPin) {
        //       if (obj?.validPin) {
        //         setCookie("CONTEST-CUSTOMERPIN", obj.validPin);
        //       }
        //       if (obj?.flagGrandPrize) {
        //         setCookie("CUSTOMER-GRANDPRIZE", obj.flagGrandPrize);
        //       }
        //       displayRegularPrizeProductDetails();
        //     } else {
        //       displayFailCasePage();
        //     }
        //   }, timeoutData);
        // } else {
        //   displayFailCasePage();
        // }
      }
    },
  });
}

/** EXPIRE CASE SUBMISSION FUNTIONS **/

function sendExpireNotificationMail(objForm) {
  //console.log("sendExpireNotificationMail");
  const formData = new FormData(objForm);
  let errorMessage = [];
  displayMainLoader();
  if (formData?.get("txtPTDFirstName")?.trim() == "") {
    errorMessage.push({
      element: objForm.querySelector("#txtPTDFirstName"),
      message: globalErrorMessages.first_name,
    });
  }

  if (formData?.get("txtPTDLastName")?.trim() == "") {
    errorMessage.push({
      element: objForm.querySelector("#txtPTDLastName"),
      message: globalErrorMessages.last_name,
    });
  }

  if (formData?.get("txtPTDEmail")?.trim() == "") {
    errorMessage.push({
      element: objForm.querySelector("#txtPTDEmail"),
      message: globalErrorMessages.email_empty,
    });
  } else if (!emailRegex.test(formData?.get("txtPTDEmail"))) {
    errorMessage.push({
      element: objForm.querySelector("#txtPTDEmail"),
      message: globalErrorMessages.email_invalid,
    });
  }

  if (formData?.get("txtPTDDay")?.trim() == "") {
    errorMessage.push({
      element: objForm.querySelector("#txtPTDDay"),
      message: globalErrorMessages.day_empty,
    });
  } else {
    let selectedDay = formData.get("txtPTDDay").trim();
    if (
      isNaN(selectedDay) ||
      !(parseInt(selectedDay) >= 1 && parseInt(selectedDay) <= 31)
    ) {
      errorMessage.push({
        element: objForm.querySelector("#txtPTDDay"),
        message: globalErrorMessages.day_invalid,
      });
    }
  }

  if (formData?.get("txtPTDMonth")?.trim() == "") {
    errorMessage.push({
      element: objForm.querySelector("#txtPTDMonth"),
      message: globalErrorMessages.month_empty,
    });
  } else {
    let selectedMonth = formData.get("txtPTDMonth").trim();
    if (
      isNaN(selectedMonth) ||
      !(parseInt(selectedMonth) >= 1 && parseInt(selectedMonth) <= 12)
    ) {
      errorMessage.push({
        element: objForm.querySelector("#txtPTDMonth"),
        message: globalErrorMessages.month_invalid,
      });
    }
  }

  if (formData?.get("txtPTDYear")?.trim() == "") {
    errorMessage.push({
      element: objForm.querySelector("#txtPTDYear"),
      message: globalErrorMessages.year_empty,
    });
  } else {
    let selectedYear = formData.get("txtPTDYear").trim();
    if (isNaN(selectedYear) || selectedYear?.length > 4) {
      errorMessage.push({
        element: objForm.querySelector("#txtPTDYear"),
        message: globalErrorMessages.year_invalid,
      });
    }
  }

  let selectedDate = new Date(
    `${formData.get("txtPTDYear").trim()}-${formData
      .get("txtPTDMonth")
      .trim()}-${formData.get("txtPTDDay").trim()}`
  );
  let currentDate = new Date();
  if (
    isNaN(selectedDate?.getUTCDate()) ||
    selectedDate?.getUTCDate() != parseInt(formData.get("txtPTDDay").trim()) ||
    isNaN(selectedDate?.getUTCMonth()) ||
    selectedDate?.getUTCMonth() + 1 !=
      parseInt(formData.get("txtPTDMonth").trim()) ||
    isNaN(selectedDate?.getUTCFullYear()) ||
    selectedDate?.getUTCFullYear() !=
      parseInt(formData.get("txtPTDYear").trim()) ||
    selectedDate?.getTime() > currentDate?.getTime()
  ) {
    errorMessage.push({
      element: objForm.querySelector("#txtPTDDay"),
      message: globalErrorMessages.date_invalid,
    });
  }

  if (
    typeof MINIMUM_AGE_REQUIRED != "undefined" &&
    parseInt(MINIMUM_AGE_REQUIRED) > 0
  ) {
    let customerAge = getAge(
      `${formData.get("txtPTDYear").trim()}-${formData
        .get("txtPTDMonth")
        .trim()}-${formData.get("txtPTDDay").trim()}`
    );
    if (parseInt(MINIMUM_AGE_REQUIRED) > customerAge) {
      errorMessage.push({
        element: objForm.querySelector("#txtPTDYear"),
        message: globalErrorMessages.age_invalid.replace(
          "##AGE##",
          MINIMUM_AGE_REQUIRED
        ),
      });
    }
  }

  if (formData?.get("txtPTDPostalCode")?.trim() == "") {
    if (formData?.get("lstPTDCountry")?.trim().toLowerCase() == "us") {
      errorMessage.push({
        element: objForm.querySelector("#txtPTDPostalCode"),
        message: globalErrorMessages.zip_code_empty,
      });
    } else {
      errorMessage.push({
        element: objForm.querySelector("#txtPTDPostalCode"),
        message: globalErrorMessages.postal_code_empty,
      });
    }
  }

  if (
    formData?.get("lstPTDProvince") == "default" ||
    formData?.get("lstPTDProvince")?.trim() == ""
  ) {
    if (formData?.get("lstPTDCountry")?.trim().toLowerCase() == "us") {
      errorMessage.push({
        element: objForm.querySelector("#lstPTDProvince"),
        message: globalErrorMessages.state,
      });
    } else {
      errorMessage.push({
        element: objForm.querySelector("#lstPTDProvince"),
        message: globalErrorMessages.province,
      });
    }
  }

  if (formData?.get("lstPTDCountry")?.trim() == "") {
    errorMessage.push({
      element: objForm.querySelector("#lstPTDCountry"),
      message: globalErrorMessages.country,
    });
  }

  if (
    provinceWisePostcode?.[formData.get("lstPTDCountry").trim()]?.[
      formData?.get("lstPTDProvince").trim()
    ] &&
    formData?.get("txtPTDPostalCode")
  ) {
    let selectedProvince =
      provinceWisePostcode[formData.get("lstPTDCountry").trim()][
        formData?.get("lstPTDProvince").trim()
      ];
    if (
      !["DE", "KR", "CZ"].includes(formData.get("lstPTDCountry").trim()) &&
      !selectedProvince.includes(
        formData.get("txtPTDPostalCode")?.trim()?.toUpperCase()?.charAt(0)
      )
    ) {
      if (formData?.get("lstPTDCountry")?.trim().toLowerCase() == "us") {
        errorMessage.push({
          element: objForm.querySelector("#txtPTDPostalCode"),
          message: globalErrorMessages.zip_code_invalid,
        });
      } else {
        console.log("7")
        errorMessage.push({
          element: objForm.querySelector("#txtPTDPostalCode"),
          message: globalErrorMessages.postal_code_invalid,
        });
      }
    }
  }

  if (
    !postalCodeRegex[formData.get("lstPTDCountry").trim().toUpperCase()]?.test(
      formData?.get("txtPTDPostalCode")
    )
  ) {
    if (formData?.get("lstPTDCountry")?.trim().toLowerCase() == "us") {
      errorMessage.push({
        element: objForm.querySelector("#txtPTDPostalCode"),
        message: globalErrorMessages.zip_code_invalid,
      });
    } else {
      console.log("8")
      errorMessage.push({
        element: objForm.querySelector("#txtPTDPostalCode"),
        message: globalErrorMessages.postal_code_invalid,
      });
    }
  }

  if (!formData?.get("chkPTDMessage")) {
    errorMessage.push({
      element: objForm.querySelector("#chkPTDMessage"),
      message: globalErrorMessages.consent_check,
    });
  }

  if (objForm?.querySelectorAll("input")) {
    resetErrorInputs(objForm);
  }
  if (errorMessage?.length > 0) {
    if (errorMessage[0]?.element?.classList) {
      errorMessage[0].element.classList.add("error-input");
      if (
        objForm?.querySelector("#divPTDErrorMessage") &&
        objForm?.querySelector("#divPTDError")
      ) {
        objForm.querySelector("#divPTDErrorMessage").innerHTML =
          errorMessage[0].message;
        objForm.querySelector("#divPTDError").style.display = "block";
      }
    }
    hideMainLoader();
  } else {
    const padZero = (val) => (val && val.length === 1 ? "0" + val : val);
    let dataValue = "";
    dataValue += `customerName@@${formData.get("txtPTDFirstName")?.trim()}##`;
    dataValue += `customerLastName@@${formData
      ?.get("txtPTDLastName")
      ?.trim()}##`;
    dataValue += `customerEmail@@${formData?.get("txtPTDEmail")?.trim()}##`;
    dataValue += `customerDob@@${formData.get("txtPTDYear").trim()}-${padZero(
      formData.get("txtPTDMonth").trim()
    )}-${padZero(formData.get("txtPTDDay").trim())}##`;
    dataValue += `postalCode@@${formData?.get("txtPTDPostalCode")?.trim()}##`;
    dataValue += `customerProvince@@${formData
      ?.get("lstPTDProvince")
      .trim()}##`;
    dataValue += `country@@${formData?.get("lstPTDCountry").trim()}##`;
    //console.log("expireFormData", dataValue);
    var url = SHERWOOD_APP_SSL_PATH + GET_PIN_DETAIL_PATH;
    $.ajax({
      url: url,
      type: "POST",
      xhrFields: {
        withCredentials: true,
      },
      crossDomain: true,
      data: {
        doAction: "sendExpireNotificationMail",
        dataValue: dataValue,
        collectionId: COLLECTION_ID,
        contestType: CONTEST_TYPE,
        contestCode: CONTEST_CODE,
        contestKlaviyoMatrixName: CONTEST_MATRIX_NAME,
        consentDetail: formData?.get("chkPTDMessage") ? "Y" : "N",
        hidLanguage: currentLanguage,
        pinServerToken: getCookieValue("PINSERVER-TOKEN"),
        r: Math.random(),
      },
      success: function (result) {
        if (result != "") {
          var obj = JSON.parse(result);
          setCookie("PINSERVER-TOKEN", obj.TOKEN);
          if (obj?.status) {
            if (document?.querySelector("#spanSucessFutureMessage")?.style) {
              document.querySelector("#spanSucessFutureMessage").style.display =
                "block";
            }
          }
        }
        hideMainLoader();
      },
    });
  }
  return false;
}


/** FUTURE CASE SUBMISSION FUNTIONS **/

function sendFutureNotification(objForm) {
  //console.log("sendFutureNotification");
  const formData = new FormData(objForm);
  let errorMessage = [];
  displayMainLoader();
  if (formData?.get("txtPTDFirstName")?.trim() == "") {
    errorMessage.push({
      element: objForm.querySelector("#txtPTDFirstName"),
      message: globalErrorMessages.first_name,
    });
  }

  if (formData?.get("txtPTDLastName")?.trim() == "") {
    errorMessage.push({
      element: objForm.querySelector("#txtPTDLastName"),
      message: globalErrorMessages.last_name,
    });
  }

  if (formData?.get("txtPTDEmail")?.trim() == "") {
    errorMessage.push({
      element: objForm.querySelector("#txtPTDEmail"),
      message: globalErrorMessages.email_empty,
    });
  } else if (!emailRegex.test(formData?.get("txtPTDEmail"))) {
    errorMessage.push({
      element: objForm.querySelector("#txtPTDEmail"),
      message: globalErrorMessages.email_invalid,
    });
  }

  if (formData?.get("txtPTDDay")?.trim() == "") {
    errorMessage.push({
      element: objForm.querySelector("#txtPTDDay"),
      message: globalErrorMessages.day_empty,
    });
  } else {
    let selectedDay = formData.get("txtPTDDay").trim();
    if (
      isNaN(selectedDay) ||
      !(parseInt(selectedDay) >= 1 && parseInt(selectedDay) <= 31)
    ) {
      errorMessage.push({
        element: objForm.querySelector("#txtPTDDay"),
        message: globalErrorMessages.day_invalid,
      });
    }
  }

  if (formData?.get("txtPTDMonth")?.trim() == "") {
    errorMessage.push({
      element: objForm.querySelector("#txtPTDMonth"),
      message: globalErrorMessages.month_empty,
    });
  } else {
    let selectedMonth = formData.get("txtPTDMonth").trim();
    if (
      isNaN(selectedMonth) ||
      !(parseInt(selectedMonth) >= 1 && parseInt(selectedMonth) <= 12)
    ) {
      errorMessage.push({
        element: objForm.querySelector("#txtPTDMonth"),
        message: globalErrorMessages.month_invalid,
      });
    }
  }

  if (formData?.get("txtPTDYear")?.trim() == "") {
    errorMessage.push({
      element: objForm.querySelector("#txtPTDYear"),
      message: globalErrorMessages.year_empty,
    });
  } else {
    let selectedYear = formData.get("txtPTDYear").trim();
    if (isNaN(selectedYear) || selectedYear?.length > 4) {
      errorMessage.push({
        element: objForm.querySelector("#txtPTDYear"),
        message: globalErrorMessages.year_invalid,
      });
    }
  }

  let selectedDate = new Date(
    `${formData.get("txtPTDYear").trim()}-${formData
      .get("txtPTDMonth")
      .trim()}-${formData.get("txtPTDDay").trim()}`
  );
  let currentDate = new Date();
  if (
    isNaN(selectedDate?.getUTCDate()) ||
    selectedDate?.getUTCDate() != parseInt(formData.get("txtPTDDay").trim()) ||
    isNaN(selectedDate?.getUTCMonth()) ||
    selectedDate?.getUTCMonth() + 1 !=
      parseInt(formData.get("txtPTDMonth").trim()) ||
    isNaN(selectedDate?.getUTCFullYear()) ||
    selectedDate?.getUTCFullYear() !=
      parseInt(formData.get("txtPTDYear").trim()) ||
    selectedDate?.getTime() > currentDate?.getTime()
  ) {
    errorMessage.push({
      element: objForm.querySelector("#txtPTDDay"),
      message: globalErrorMessages.date_invalid,
    });
  }

  if (
    typeof MINIMUM_AGE_REQUIRED != "undefined" &&
    parseInt(MINIMUM_AGE_REQUIRED) > 0
  ) {
    let customerAge = getAge(
      `${formData.get("txtPTDYear").trim()}-${formData
        .get("txtPTDMonth")
        .trim()}-${formData.get("txtPTDDay").trim()}`
    );
    if (parseInt(MINIMUM_AGE_REQUIRED) > customerAge) {
      errorMessage.push({
        element: objForm.querySelector("#txtPTDYear"),
        message: globalErrorMessages.age_invalid.replace(
          "##AGE##",
          MINIMUM_AGE_REQUIRED
        ),
      });
    }
  }

  if (formData?.get("txtPTDPostalCode")?.trim() == "") {
    if (formData?.get("lstPTDCountry")?.trim().toLowerCase() == "us") {
      errorMessage.push({
        element: objForm.querySelector("#txtPTDPostalCode"),
        message: globalErrorMessages.zip_code_empty,
      });
    } else {
      errorMessage.push({
        element: objForm.querySelector("#txtPTDPostalCode"),
        message: globalErrorMessages.postal_code_empty,
      });
    }
  }

  if (
    formData?.get("lstPTDProvince") == "default" ||
    formData?.get("lstPTDProvince")?.trim() == ""
  ) {
    if (formData?.get("lstPTDCountry")?.trim().toLowerCase() == "us") {
      errorMessage.push({
        element: objForm.querySelector("#lstPTDProvince"),
        message: globalErrorMessages.state,
      });
    } else {
      errorMessage.push({
        element: objForm.querySelector("#lstPTDProvince"),
        message: globalErrorMessages.province,
      });
    }
  }

  if (formData?.get("lstPTDCountry")?.trim() == "") {
    errorMessage.push({
      element: objForm.querySelector("#lstPTDCountry"),
      message: globalErrorMessages.country,
    });
  }

  if (
    provinceWisePostcode?.[formData.get("lstPTDCountry").trim()]?.[
      formData?.get("lstPTDProvince").trim()
    ] &&
    formData?.get("txtPTDPostalCode")
  ) {
    let selectedProvince =
      provinceWisePostcode[formData.get("lstPTDCountry").trim()][
        formData?.get("lstPTDProvince").trim()
      ];
    if (
      !["DE", "KR", "CZ"].includes(formData.get("lstPTDCountry").trim()) &&
      !selectedProvince.includes(
        formData.get("txtPTDPostalCode")?.trim()?.toUpperCase()?.charAt(0)
      )
    ) {
      if (formData?.get("lstPTDCountry")?.trim().toLowerCase() == "us") {
        errorMessage.push({
          element: objForm.querySelector("#txtPTDPostalCode"),
          message: globalErrorMessages.zip_code_invalid,
        });
      } else {
        console.log("1")
        errorMessage.push({
          element: objForm.querySelector("#txtPTDPostalCode"),
          message: globalErrorMessages.postal_code_invalid,
        });
      }
    }
  }

  if (
    !postalCodeRegex[formData.get("lstPTDCountry").trim().toUpperCase()]?.test(
      formData?.get("txtPTDPostalCode")
    )
  ) {
    if (formData?.get("lstPTDCountry")?.trim().toLowerCase() == "us") {
      errorMessage.push({
        element: objForm.querySelector("#txtPTDPostalCode"),
        message: globalErrorMessages.zip_code_invalid,
      });
    } else {
      console.log("9")
      errorMessage.push({
        element: objForm.querySelector("#txtPTDPostalCode"),
        message: globalErrorMessages.postal_code_invalid,
      });
    }
  }

  if (!formData?.get("chkPTDMessage")) {
    errorMessage.push({
      element: objForm.querySelector("#chkPTDMessage"),
      message: globalErrorMessages.consent_check,
    });
  }

  if (objForm?.querySelectorAll("input")) {
    resetErrorInputs(objForm);
  }
  if (errorMessage?.length > 0) {
    if (errorMessage[0]?.element?.classList) {
      errorMessage[0].element.classList.add("error-input");
      if (
        objForm?.querySelector("#divPTDErrorMessage") &&
        objForm?.querySelector("#divPTDError")
      ) {
        objForm.querySelector("#divPTDErrorMessage").innerHTML =
          errorMessage[0].message;
        objForm.querySelector("#divPTDError").style.display = "block";
      }
    }
    hideMainLoader();
  } else {
    const padZero = (val) => (val && val.length === 1 ? "0" + val : val);
    let dataValue = "";
    dataValue += `customerName@@${formData.get("txtPTDFirstName")?.trim()}##`;
    dataValue += `customerLastName@@${formData?.get("txtPTDLastName")?.trim()}##`;
    dataValue += `customerEmail@@${formData?.get("txtPTDEmail")?.trim()}##`;
    dataValue += `customerDob@@${formData.get("txtPTDYear").trim()}-${padZero(formData.get("txtPTDMonth").trim())}-${padZero(formData.get("txtPTDDay").trim())}##`;
    dataValue += `postalCode@@${formData?.get("txtPTDPostalCode")?.trim()}##`;
    dataValue += `customerProvince@@${formData?.get("lstPTDProvince").trim()}##`;
    dataValue += `country@@${formData?.get("lstPTDCountry").trim()}##`;
    //console.log("futureFormData", dataValue);
    var url = SHERWOOD_APP_SSL_PATH + GET_PIN_DETAIL_PATH;
    $.ajax({
      url: url,
      type: "POST",
      xhrFields: {
        withCredentials: true,
      },
      crossDomain: true,
      data: {
        doAction: "sendFutureNotificationMail",
        dataValue: dataValue,
        collectionId: COLLECTION_ID,
        contestType: CONTEST_TYPE,
        contestCode: CONTEST_CODE,
        contestKlaviyoMatrixName: CONTEST_MATRIX_NAME,
        consentDetail: formData?.get("chkPTDMessage") ? "Y" : "N",
        hidLanguage: currentLanguage,
        pinServerToken: getCookieValue("PINSERVER-TOKEN"),
        r: Math.random(),
      },
      success: function (result) {
        if (result != "") {
          var obj = JSON.parse(result);
          setCookie("PINSERVER-TOKEN", obj.TOKEN);
          if (obj?.status) {
            if (
              document?.querySelector("#spanSucessFutureMessage")?.style
            ) {
              document.querySelector("#spanSucessFutureMessage").style.display = 'block';
            }
          }
        }
        hideMainLoader();
      },
    });
  }
  return false;
}

function reloadIframe() {
  //console.log("reloadIframe");
  if (document?.querySelector("#ifrmCaptcha")) {
    let url = SHERWOOD_APP_SSL_PATH + CAPTCHA_IFRAME_PATH;
    if (getCookieValue("PINSERVER-TOKEN")) {
      url = url + "?pinServerToken=" + getCookieValue("PINSERVER-TOKEN");
    }
    document.querySelector("#ifrmCaptcha").setAttribute("src", url);
  }
}

function changeProductVariant(objForm) {
  //console.log("changeProductVariant");
  if (
    objForm?.getAttribute("product-id") &&
    typeof productArray != "undefined"
  ) {
    let selectedProductId = objForm?.getAttribute("product-id");
    let formData = new FormData(objForm);
    let selectedOptions = [];
    for (const [key, value] of formData.entries()) {
      if (key != "variantId") {
        selectedOptions.push(value);
      }
    }
    if (
      selectedOptions?.length &&
      productArray?.some((itm) => itm.id == selectedProductId)
    ) {
      let selectedProduct = productArray.find(
        (itm) => itm.id == selectedProductId
      );
      if (selectedProduct?.variants?.length) {
        let selectedVariant = selectedProduct.variants.find((itm) =>
          itm.options.every((opt) => selectedOptions.includes(opt))
        );
        if (typeof selectedVariant != "undefined") {
          if (selectedVariant?.available == true) {
            if (objForm?.querySelector("#variantId")?.value) {
              objForm.querySelector("#variantId").value =
                selectedVariant.id.toString();
            }
            if (
              objForm?.querySelector("#btnAddtoCart")?.removeAttribute &&
              typeof ADD_TO_CART_LABEL != "undefined"
            ) {
              objForm
                .querySelector("#btnAddtoCart")
                .removeAttribute("disabled");
              objForm.querySelector("#btnAddtoCart").innerHTML =
                ADD_TO_CART_LABEL;
            }
          } else {
            if (objForm?.querySelector("#variantId")?.value) {
              objForm.querySelector("#variantId").value =
                selectedVariant.id.toString();
            }
            if (
              objForm?.querySelector("#btnAddtoCart")?.setAttribute &&
              typeof OUT_OF_STOCK_LABEL != "undefined"
            ) {
              objForm
                .querySelector("#btnAddtoCart")
                .setAttribute("disabled", true);
              objForm.querySelector("#btnAddtoCart").innerHTML =
                OUT_OF_STOCK_LABEL;
            }
          }
        }
      }
    }
  }
}

function contestAddToCart(objForm) {
  //console.log("contestAddToCart");
  displayMainLoader();
  let formData = new FormData(objForm);
  if (formData?.get("variantId") && objForm?.getAttribute("product-id")) {
    verifyProductAndAddToCart(
      objForm?.getAttribute("product-id"),
      formData?.get("variantId"),
      objForm
    );
  }
  return false;
}

function verifyProductAndAddToCart(
  productId = "",
  variantId = "",
  formElement = {}
) {
  //console.log("verifyProductAndAddToCart");
  if (
    productId != "" &&
    variantId != "" &&
    typeof productArray != "undefined"
  ) {
    let errorMessage = [];
    let selectedProduct = productArray.find(
      (itm) => itm.id.toString() == productId.toString()
    );
    if (typeof selectedProduct != "undefined") {
      let selectedVariant = selectedProduct.variants.find(
        (itm) => itm.id.toString() == variantId.toString()
      );
      if (typeof selectedVariant != "undefined") {
        //console.log("selectedProduct", selectedProduct);
        //console.log("selectedVariant", selectedVariant);
        let sessionData = {
          SELECTEDCONTESTPRODUCT: selectedVariant.id + "-" + 1,
        };
        let productData = [selectedProduct.id + "-" + 1];
        let url = SHERWOOD_APP_SSL_PATH + SET_SESSION_PATH;
        $.ajax({
          url: url,
          async: false,
          type: "POST",
          xhrFields: {
            withCredentials: true,
          },
          crossDomain: true,
          data: {
            doAction: "setSession",
            setSessionInfo: sessionData,
            validateProduct: productData,
            pinServerToken: getCookieValue("PINSERVER-TOKEN"),
            flagCheckSession: "Y",
            r: Math.random(),
          },
          success: function (result) {
            if (result != "") {
              var obj = JSON.parse(result);
              //console.log("AJAX RES", JSON.stringify(obj));
              setCookie("PINSERVER-TOKEN", obj?.TOKEN);
              if (obj?.status && obj?.sessionData?.["PININFO"] == "Y") {
                if (obj?.sessionData?.["AGREEDTERMS"]) {
                  setCookie("CUSTOMER-AGREETC", obj.sessionData["AGREEDTERMS"]);
                }
                checkAndRemoveContestProduct();
                var customerPinCookie = getCookieValue("CONTEST-CUSTOMERPIN");
                var customeragreTc = getCookieValue("CUSTOMER-AGREETC");
                var customerPinServerToken = getCookieValue("PINSERVER-TOKEN");
                if (customerPinCookie) {
                  var strToChangeChange = {
                    id: selectedVariant.id.toString(),
                    quantity: 1,
                    attributes: {
                      VALIDATEPIN: customerPinCookie,
                      COLLECTIONID: COLLECTION_ID,
                      CONTESTCODE: CONTEST_CODE,
                      AGREEDTERMS: customeragreTc ? customeragreTc : "N",
                      "PINSERVER-TOKEN": customerPinServerToken,
                    },
                  };
                  $.ajax({
                    url: "/cart/add.js",
                    method: "POST",
                    async: false,
                    data: strToChangeChange,
                    dataType: "json",
                  });
                  if (flagRedirectToCart) {
                    //console.log("redirecting to cart");
                    if (formElement?.reset) {
                      formElement.reset();
                    }
                    window.location.href = CART_REDIRECT_PATH;
                  }
                }
              } else {
                errorMessage.push("Server error");
              }
            } else {
              errorMessage.push("Response error");
            }
          },
        });
      } else {
        errorMessage.push("Variant not found");
      }
    } else {
      errorMessage.push("Product not found");
    }
    if (errorMessage?.length) {
      removeFailSessionCookies("all");
      displayFailCasePage();
      hideMainLoader();
      if (
        formElement?.querySelector("#divDateProvinceError") &&
        formElement?.querySelector(".error-msg")?.style
      ) {
        formElement.querySelector("#divDateProvinceError").innerHTML =
          errorMessage.join(", ");
        formElement.querySelector(".error-msg").style.display = "block";
      }
    } else {
      hideMainLoader();
      if (
        formElement?.querySelector("#divDateProvinceError") &&
        formElement?.querySelector(".error-msg")?.style
      ) {
        formElement.querySelector("#divDateProvinceError").innerHTML = "";
        formElement.querySelector(".error-msg").style.display = "none";
      }
    }
  }
}

function checkAndRemoveContestProduct(params) {
  //console.log("checkAndRemoveContestProduct");
  if (typeof productArray != "undefined") {
    let removeProductArray = [];
    let collectionProductIds = productArray?.map((itm) => itm.id.toString());
    $.ajax({
      url: GET_CART_PATH,
      async: false,
      dataType: "json",
      success: function (response) {
        lines = response.items;
        // loop through line item and add properties
        if (lines?.length) {
          lines.forEach((itm) => {
            if (
              itm?.variant_id &&
              itm?.product_id &&
              collectionProductIds?.includes(itm.product_id.toString())
            ) {
              removeProductArray.push(itm.variant_id.toString());
            }
          });
        }
      },
    });
    if (removeProductArray?.length) {
      removeProductFromCart(removeProductArray);
    }
  }
}

function removeProductFromCart(productArray = []) {
  if (productArray?.length) {
    productArray.forEach((itm) => {
      $.ajax({
        url: CART_CHANGE_PATH,
        method: "POST",
        async: false,
        data: { id: itm, quantity: 0 },
      });
    });
  }
}

function initializeSlider(params) {
  if (typeof $ != "undefined" && $(".vertical-gallery")?.length) {
    $(".vertical-gallery").slick();
  }
}

function checkFocusNext(textbox) {
  //console.log("checkFocusNext");
  if (textbox?.getAttribute("maxlength")) {
    let maxLength = parseInt(textbox.getAttribute("maxlength"));
    if (
      textbox?.value?.length >= maxLength &&
      textbox?.nextElementSibling?.focus
    ) {
      textbox.nextElementSibling.focus();
    }
  }
}

function getAge(dateString) {
  var today = new Date();
  var birthDate = new Date(dateString);
  var age = today.getUTCFullYear() - birthDate.getUTCFullYear();
  var m = today.getUTCMonth() - birthDate.getUTCMonth();
  if (m < 0 || (m === 0 && today.getUTCDate() < birthDate.getUTCDate())) {
    age--;
  }
  return age;
}

function displayProductDetail(element = {}) {
  if (
    element?.getAttribute("product-id") &&
    typeof productDetailsArray != "undefined" &&
    productDetailsArray[element.getAttribute("product-id")] &&
    document?.querySelector("#divProductDispDetail")
  ) {
    document.querySelector("#divProductDispDetail").innerHTML =
      productDetailsArray[element.getAttribute("product-id")];
    initializeSlider();
    document
      .querySelector("#divProductDispDetail")
      .scrollIntoView({ behavior: "smooth" });
  }
}

function validateUserCheckout(params) {
  //console.log("validateUserCheckout");
  if (typeof CART_DATA != "undefined" && CART_DATA?.items?.length) {
    let checkoutArray = {};
    let cartAttributes = CART_DATA.attributes;
    CART_DATA.items.forEach((item) => {
      if (item?.tags?.includes("CONTEST-PRODUCT-Y")) {
        checkoutArray[item.product_id] = {
          quantity: item.quantity.toString(),
          tag: item.tags.join(" "),
          variantId: item.variant_id.toString(),
        };
      }
    });
    if (Object?.keys(checkoutArray)?.length) {
      let url = SHERWOOD_APP_SSL_PATH + GET_PIN_DETAIL_PATH;
      $.ajax({
        url: url,
        async: false,
        type: "POST",
        xhrFields: {
          withCredentials: true,
        },
        crossDomain: true,
        data: {
          doAction: "validateUserCheckout",
          verifyData:
            "CUSTOMERAGE@@PININFO@@SELECTEDCONTESTPRODUCT@@CUSTOMERDOB",
          checkoutItem: JSON.stringify(checkoutArray),
          checkoutAttribute: cartAttributes,
          pinServerToken: getCookieValue("PINSERVER-TOKEN"),
          r: Math.random(),
        },
        success: function (result) {
          if (result != "") {
            var obj = JSON.parse(result);
            setCookie("PINSERVER-TOKEN", obj.TOKEN);
            if (obj?.status) {
              if (obj?.flagValidUser) {
              } else {
                var removeProductDetail = JSON.parse(obj.removeCartProduct);
                var strToChange = {};
                strToChange.updates = {};
                for (const property in removeProductDetail) {
                  strToChange.updates[removeProductDetail[property]] = 0;
                }
                //return false;
                if (Object?.keys(strToChange)?.length) {
                  $.ajax({
                    url: "/cart/update.js",
                    method: "POST",
                    async: false,
                    data: strToChange,
                    dataType: "json",
                  });
                  removeFailSessionCookies("all");
                  window.location.href = CART_REDIRECT_PATH;
                }
              }
            }
          }
        },
      });
    }
  }
}

function initPaymentClickEvent() {
  //console.log("initPaymentClickEvent");
  // bind click event for payment page button
  if (document?.querySelector(".contest-btn-checkout")) {
    //console.log("button found");
    document.querySelector(".contest-btn-checkout").onclick = function (e) {
      var returnData = callPaymentClick();
      if (returnData.status) {
        let cartAttributes = CART_DATA.attributes;
        cartAttributes.VERIFIEDPINRECID = returnData?.pinRecId;
        //console.log("cartAttributes", cartAttributes);
        var strToChange = {};
        strToChange.attributes = cartAttributes;
        $.ajax({
          url: "/cart/update.js",
          method: "POST",
          async: false,
          data: strToChange,
          dataType: "json",
        });
        return true;
      } else {
        return false;
      }
    };
  }
}

function callPaymentClick() {
  var returnArrDetail = {};
  if (typeof CART_DATA != "undefined" && CART_DATA?.items?.length) {
    let checkoutArray = {};
    let cartAttributes = CART_DATA.attributes;
    CART_DATA.items.forEach((item) => {
      if (item?.tags?.includes("CONTEST-PRODUCT-Y")) {
        checkoutArray[item.product_id] = {
          quantity: item.quantity.toString(),
          tag: item.tags.join(" "),
          variantId: item.variant_id.toString(),
        };
      }
    });
    if (Object?.keys(checkoutArray)?.length) {
      let flagAllowSubmitForm = false;
      let url = SHERWOOD_APP_SSL_PATH + GET_PIN_DETAIL_PATH;
      $.ajax({
        url: url,
        type: "POST",
        async: false,
        xhrFields: {
          withCredentials: true,
        },
        crossDomain: true,
        data: {
          doAction: "validateUserPayment",
          verifyData:
            "CUSTOMERAGE@@PININFO@@SELECTEDCONTESTPRODUCT@@CUSTOMERDOB",
          checkoutItem: JSON.stringify(checkoutArray),
          checkoutAttribute: cartAttributes,
          pinServerToken: getCookieValue("PINSERVER-TOKEN"),
          r: Math.random(),
        },
        success: function (result) {
          var obj = JSON.parse(result);
          setCookie("PINSERVER-TOKEN", obj.TOKEN);
          if (obj?.status) {
            if (obj?.flagValidUser) {
              returnArrDetail["status"] = true;
              returnArrDetail["pinRecId"] = obj?.VERIFIEDPINRECID;
            } else {
              var removeProductDetail = JSON.parse(obj.removeCartProduct);
              var strToChange = {};
              strToChange.updates = {};
              for (const property in removeProductDetail) {
                strToChange.updates[removeProductDetail[property]] = 0;
              }
              //return false;
              returnArrDetail["status"] = true;
              returnArrDetail["removeData"] = strToChange;
            }
          }
        },
      });
    }
  }
  return returnArrDetail;
}

function getFormData(object = {}) {
  const formData = new FormData();
  Object.keys(object).forEach((key) => formData.append(key, object[key]));
  return formData;
}

// document.addEventListener('DOMContentLoaded', () => {
//   document.querySelectorAll('.custom-checkbox-label').forEach(label => {
//     label.addEventListener('click', () => {
//       document.querySelectorAll('.custom-checkbox').forEach(checkbox => {
//         checkbox.click();
//       });
//     });
//   });
// });

function fileUploadEvent(fileElement) {
  //console.log("fileUploadEvent", fileElement);
  if (
    fileElement?.files?.length > 0 &&
    document?.querySelector("#fileInfo") &&
    document?.querySelector("#fileName") &&
    document?.querySelector(".upload-btn.initial")
  ) {
    document.querySelector("#fileName").innerHTML = fileElement.files[0].name;
    document.querySelector("#fileInfo").style.display = "block";
    document.querySelector(".upload-btn.initial").style.display = "none";
  }
}

function fileRemoveEvent(params) {
  //console.log("fileRemoveEvent");
  let fileElement = document.querySelector("#PTDverificationImage");
  if (
    fileElement?.files?.length > 0 &&
    document?.querySelector("#fileInfo") &&
    document?.querySelector("#fileName") &&
    document?.querySelector(".upload-btn.initial")
  ) {
    fileElement.value = ""; // Reset the file input
    document.querySelector("#fileName").innerHTML = "";
    document.querySelector("#fileInfo").style.display = "none";
    document.querySelector(".upload-btn.initial").style.display = "inline-flex";
  }
}

// $(document).ready(function () {
//   $('.custom-checkbox-label').on('click', function () {
//     //console.log("click");
//     const $checkbox = $(this).closest('.checkbox-container').find('.custom-checkbox');
//     //console.log("checkbox", $checkbox);
//     $checkbox.prop('checked', !$checkbox.prop('checked')); // Toggle this one only
//   });
// });

function initialCheckboxClick() {
  $(".custom-checkbox-label")
    .off("click")
    .on("click", function () {
      //console.log("click here");
      const $checkbox = $(this)
        .closest(".checkbox-container")
        .find(".custom-checkbox");
      //console.log("checkbox", $checkbox);
      $checkbox.prop("checked", !$checkbox.prop("checked"));
    });
}